export class ListFilter {
    constructor(p: number, col: string, dir: string) { 
        this.page = 1;
        this.pageSize = p;
        this.sortedColumn = col;
        this.sortedDirection = dir;
    }

    page: number;
    pageSize: number;
    sortedColumn: string;
    sortedDirection: string;

    public showing(ct: number): string {
        if(ct == 0){
            return 'Showing 0 results';
        }
        return 'Showing ' + (((this.page - 1) * this.pageSize) + 1) + '-' + (Math.min(ct, this.page * this.pageSize)) + ' of ' + ct + ' results';
    }
    
}